import { Action } from '@ngrx/store';
import { SimChoiceInterface } from '../../models/sim-choice.interface';

export enum ESimChoiceActions {
  UpdateSimChoice = '[SIM_CHOICE] Update sim choice'
}

export class UpdateSimChoice implements Action {
  public readonly type = ESimChoiceActions.UpdateSimChoice;
  constructor(public payload: SimChoiceInterface) {}
}

export type SimChoiceActions = UpdateSimChoice;
